import { useEffect, useState } from 'react';

interface UseInfiniteScrollOptions {
  hasNextPage: boolean;
  isFetching: boolean;
  onLoadMore: () => void;
  rootMargin?: string;
}

export function useInfiniteScroll({
  hasNextPage,
  isFetching,
  onLoadMore,
  rootMargin = '50px',
}: UseInfiniteScrollOptions) {
  const [sentinelElement, setSentinelElement] = useState<HTMLElement | null>(null);
  const [containerElement, setContainerElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!containerElement || !sentinelElement) return;

    const observer = new IntersectionObserver(
      entries => {
        const target = entries[0];
        if (target.isIntersecting && hasNextPage && !isFetching) {
          onLoadMore();
        }
      },
      {
        root: containerElement,
        rootMargin,
      }
    );

    observer.observe(sentinelElement);
    return () => observer.disconnect();
  }, [containerElement, sentinelElement, hasNextPage, isFetching, onLoadMore, rootMargin]);

  return {
    setContainerElement,
    setSentinelElement,
  };
}
